import { useState } from 'react';

export default function NotificationBar({ contentfulEntry }) {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const fieldContent = contentfulEntry;

    // Only show the banner if a valid message exists
    if (!fieldContent?.message) {
        return null;
    }

    return (
        <div
            className={`w-full transition-all duration-300 ease-in-out z-50 text-white ${isCollapsed ? 'h-2 cursor-pointer hover:h-3' : 'h-18 sm:h-16 md:h-14 lg:h-12'
                }`}
            style={{
                backgroundColor: fieldContent.backgroundColour || '#5575BF',
            }}
            onClick={() => isCollapsed && setIsCollapsed(false)}
        >
            {!isCollapsed && (
                <div className="container mx-auto px-4 sm:px-6 md:px-8 h-full flex flex-col md:flex-row items-center justify-between">
                    {/* Left Empty Space */}
                    <div className="flex-1 hidden lg:block" />

                    {/* Center Section with Description */}
                    <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 w-full sm:w-auto">
                        {/* Notification Message */}
                        <p className="text-base text-center sm:text-left w-full sm:w-auto">
                            {fieldContent.message}
                        </p>

                        <div className="flex justify-center items-center gap-2 mt-2 sm:mt-0">
                            {/* Call-to-Action Button */}
                            <a
                                href={fieldContent.ctaDestination || "#"}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-white hover:text-white/90 text-base font-semibold underline focus:outline-none decoration-dashed hover:no-underline decoration-[1.5px] underline-offset-4"
                            >
                                {fieldContent.ctaText || "Refer Here"}
                            </a>

                            {/* Collapse Button */}
                            <button
                                className="p-1 hover:text-white/80 rounded focus:outline-none"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setIsCollapsed(true);
                                }}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-6 w-6"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                >
                                    <polyline points="18 15 12 9 6 15"></polyline>
                                </svg>
                            </button>
                        </div>
                    </div>

                    <div className="flex-1 flex items-center justify-end gap-4 mt-2 sm:mt-0">
                        {/* <button
                            className="text-sm text-white hover:text-white/90 focus:outline-none decoration-dashed underline hover:no-underline decoration-[1.5px] underline-offset-4"
                            onClick={(e) => {
                                e.stopPropagation();
                                setIsHidden(true);
                            }}
                        >
                            Don't show again
                        </button> */}
                    </div>

                </div>
            )}
        </div>
    );
}
